export type CompatibilityError = {
  code: "FORCE_UPDATE" | "MAINTENANCE";
  message: string;
  updateUrl?: string | null;
};

type Listener = (error: CompatibilityError) => void;
const listeners = new Set<Listener>();

export function publishCompatibilityError(error: CompatibilityError) {
  listeners.forEach((listener) => listener(error));
}

export function subscribeCompatibilityError(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
